/* screens/dev/UiKit.jsx — витрина общих слоёв S1 (// заменяет: S0-витрину).
   Живая документация всех примитивов и паттернов: каждый со всеми состояниями.
   Тулбар: переключатель плотности compact/comfortable + тёмный задел (light/dark).
   Колонка-якорь (AnchorNav) на md+. Доступна по /dev/uikit.
   ХЕНДОФФ → frontend/src/pages/dev/UIKitDemo.jsx. */

import React from 'react';
import { AnchorNav } from '../../components/patterns/Tabs.jsx';
import { Segmented } from '../../components/ui/Field.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { ScreenHeader } from '../../components/ui/Metric.jsx';
import { BadgesSection, ButtonsSection, ChipsSection, IconsSection, PaletteSection, TypographySection } from './UiKitParts1.jsx';
import { FormsSection, MetricsSection, TabsSection } from './UiKitParts2.jsx';
import { CardsSection, DataTableSection, OverlaysSection, StatesSection, WidgetSection } from './UiKitParts3.jsx';
import { TTKEditorSection } from './UiKitParts4.jsx';
import { KnowledgeSection } from './UiKitParts5.jsx';
import { AuthSection } from './UiKitParts6.jsx';

  const { useState } = React;

  const NAV = [
    { id: 'type', num: 1, label: 'Типографика' },
    { id: 'palette', num: 2, label: 'Палитра' },
    { id: 'icons', num: 3, label: 'Иконки' },
    { id: 'buttons', num: 4, label: 'Кнопки' },
    { id: 'badges', num: 5, label: 'Бейджи' },
    { id: 'chips', num: 6, label: 'Чипы' },
    { id: 'forms', num: 7, label: 'Поля ввода' },
    { id: 'metrics', num: 8, label: 'Метрики' },
    { id: 'tabs', num: 9, label: 'Табы' },
    { id: 'table', num: 10, label: 'DataTable' },
    { id: 'cards', num: 11, label: 'Карточки' },
    { id: 'widget', num: 12, label: 'Виджеты' },
    { id: 'overlays', num: 13, label: 'Оверлеи' },
    { id: 'states', num: 14, label: 'Состояния' },
    { id: 'ttk', num: 15, label: 'Редактор ТТК' },
    { id: 'knowledge', num: 16, label: 'База знаний' },
    { id: 'auth', num: 17, label: 'Авторизация' },
  ];

  function UiKit() {
    const [density, setDensity] = useState('comfortable');
    const [theme, setTheme] = useState('light');

    return (
      <div className="uikit-page">
        <div className="uikit-toolbar">
          <div className="cluster cluster-6 grow" style={{ minWidth: 0 }}>
            <Icon name="grid" size={18} className="text-accent" />
            <span className="t-h4">UI Kit · библиотека S1</span>
            <span className="badge badge--accent badge--sm">{NAV.length} секций</span>
          </div>
          <div className="uikit-toolbar__group">
            <span className="uikit-toolbar__label">Плотность</span>
            <Segmented size="sm" value={density} onChange={setDensity}
              options={[{ value: 'comfortable', label: 'Comfortable' }, { value: 'compact', label: 'Compact' }]} />
          </div>
          <div className="uikit-toolbar__group">
            <span className="uikit-toolbar__label">Тема</span>
            <Segmented size="sm" value={theme} onChange={setTheme}
              options={[{ value: 'light', label: 'Светлая', icon: 'sun' }, { value: 'dark', label: 'Тёмная', icon: 'moon' }]} />
          </div>
        </div>

        <div className="uikit-layout" data-density={density} data-theme={theme}>
          <aside className="uikit-rail">
            <AnchorNav items={NAV} orientation="vertical" offset={120} />
          </aside>
          <main className="uikit-content">
            <ScreenHeader eyebrow="Restorium · редизайн «Линотип»"
              title="Библиотека интерфейса"
              subtitle="Все примитивы и паттерны со всеми состояниями. Меняйте плотность и тему в шапке — компоненты реагируют. Сужайте окно до 360px: DataTable → карточки, Select → fullscreen, таблицы и табы остаются доступными." />

            <TypographySection />
            <PaletteSection />
            <IconsSection />
            <ButtonsSection />
            <BadgesSection />
            <ChipsSection />
            <FormsSection />
            <MetricsSection />
            <TabsSection />
            <DataTableSection />
            <CardsSection />
            <WidgetSection />
            <OverlaysSection />
            <StatesSection />
            <TTKEditorSection />
            <KnowledgeSection />
            <AuthSection />
          </main>
        </div>
      </div>
    );
  }

export { UiKit };
